<template>
<div>
  <dai-tarjeta-contenedor-mapa id="mapa-vih" :colapsada="false">
    <template v-slot:header>

      <h2>Casos positivos de VIH de las personas participantes de un estudio en la Clínica Condesa</h2>
      <div class="responsive-fecha-texto">
        <p class="fecha">{{obtenerFechaActualizacion}}</p>
        <p class="texto">Los filtros muestran aquellos participantes con información geoespacial</p>

      </div>
      <button type="button" class="boton-modal" @click="$refs.modal_tablero_mapa.abrirModal()">
          Acerca del mapa
      </button>
      <modal ref="modal_tablero_mapa" :posicion_boton="'arriba'">
          <template v-slot:cuerpo>
          <p>El mapa representa la localización geográfica de la residencia de todas las personas que participan en el estudio (incluyendo a las personas que se encuentran dentro de la red genética de transmisión de VIH y las que no lo están), a nivel de municipio/alcaldía. Mientras más grande sea el círculo, existen más participantes residentes en la localidad correspondiente. Los datos de cada municipio pueden obtenerse pasando el cursor sobre el círculo correspondiente. </p>
          </template>
      </modal>

      <div class="info-georef mostrar-cel">
        <p class="m-0">
          <strong>Participantes con información georeferencial:</strong> {{datosMapa.datos_mapa.porcentaje.toFixed(2)}}% ({{datosMapa.datos_mapa.cantidad.toLocaleString()}})
        </p>
        <p class="m-0 texto-gris">
          <strong>Muestra total:</strong> {{datosMapa.datos_mapa.total.toLocaleString()}} participantes
        </p>
      </div>
    </template>
    <div class="contenedor-principal">

      <div class="izquierda"
        v-bind:class="{'vista-movil-colapsada': !vistaMovilExpandida}"
      >
        <div>
          <div class="info-georef mostrar-esc">
            <p class="m-0">
              <strong>Participantes con información georeferencial:</strong> {{datosMapa.datos_mapa.porcentaje.toFixed(2)}}% ({{datosMapa.datos_mapa.cantidad.toLocaleString()}})
            </p>
            <p class="m-0 texto-gris">
              <strong>Muestra total:</strong> {{datosMapa.datos_mapa.total.toLocaleString()}} participantes
            </p>
          </div>
          <ControlSexo />
          <ControlEdad />
          <ControlSeguridadSocial />
        </div>
      </div>

      <div class="mapa">
        <div class="contenedor-selectores">
          <SelectorEstatal />
          <SelectorMunicipal />
        </div>

        <dai-mapa
          ref="componenteMapa"
          :zoom-on-scroll="false"
          :extension="[
            -99.3649242001857971, 18.9882366601461806, -98.9403028204122421,
            19.69527572798008391,
          ]"
          @reset_view="resetMapa" >
          <dai-capa-xyz id="capa_base" />
          <dai-capa-geojson
            v-for="capa in capasWfs"
            :key="`${capa.id}_wfs_${renderCapakey}`"
            :id="`id_${capa.id}_wfs_${renderCapakey}`"
            :titulo="capa.titulo"
            :datos="capa.geojson.contenidoFiltrado"
            :estilo-capa="capa.estilo"
            :z-index="capa.z_index"
            :contenido-tooltip="capa.tooltip"
            @click_feature="capa.click"
            :zoom-al-dar-click="false"
          />

          <dai-capa-geojson
            v-for="capa in capasClasificables"
            :key="capa.id"
            :id="`id_${capa.id}`"
            :titulo="capa.titulo"
            :datos="capa.geojson.contenidoFiltrado"
            :estilo-capa="capa.estilo"
            :visible="capa.visible"
            :z-index="capa.z_index"
            :reglas-estilo-capa="capa.clasificasiones"
            :contenido-tooltip="capa.tooltip"
            @click_feature="capa.click"
            :zoom-al-dar-click="false"
          />


          <dai-capa-wms
            :id="`id_${estados.id}_wms_`"
            :titulo="estados.titulo"
            :url="estados.wms.url"
            :parametros="estados.wms.parametros"
            :z-index="estados.z_index"
            :visible="estados.visible"
          />

          <dai-capa-wms
            :id="`id_${municipios_wms.id}_wms_`"
            :titulo="municipios_wms.titulo"
            :url="municipios_wms.wms.url"
            :parametros="municipios_wms.wms.parametros"
            :z-index="municipios_wms.z_index"
            :visible="municipios_wms.visible"
          />


        </dai-mapa>
      </div>

      <ControlReproductor />

      <div class="leyenda-mapa">
        <dai-leyenda-mapa
          v-for="capa in capasClasificables"
          :key="capa.id"
          :para="`id_${capa.id}`"
          :titulo="capa.tituloLeyenda"
          :mostrar-boton-alterna-todos="true"
          class="leyenda-municipal"
          :style="{display:capa.visible?'':'none'}"
        />

        <div class="header-legend" v-if="capasClasificables.length==0">
          <p class="title">No hay datos para clasificar</p>
        </div>
      </div>

      <div class="derecha"
        v-bind:class="{'vista-movil-colapsada': !vistaMovilExpandida}"
      >
        <div>
          <ControlResistencia />
          <Linfocitos
						class="flex-1_2 grafica-estadistica-cluster separador-top"
						:barras_apiladas_id="'barras-linfocitos'"
						:datos="data_linfocitos"
						:nombre_variables="{nombre:'nombre'}"
						:variables='[{"id":"cantidad","nombre":"nombre","color":"#333333"}]'
						:alto_vis="190"
            :titulo_eje_x="'Conteo de linfocitos T CD4+'"
            :titulo_eje_x2="'(células/mm\u00B3 de sangre)'"
            :titulo_eje_y="'Cantidad de participantes'"
						:margen=" {arriba:5,abajo:40,izquierda:40,derecha:20}"
            ref="linfobarras"
					/>
        </div>
      </div>
    </div>

    <button class="btn-ver-mas btn solo-en-movil" @click="vistaMovilExpandida=!vistaMovilExpandida">
      {{vistaMovilExpandida ? "Menos información": "Más información"}}
    </button>
  </dai-tarjeta-contenedor-mapa>
</div>
</template>


<script>
import { mapMutations, mapGetters, mapState} from 'vuex';
import '@/components/mapa/mapa.scss';

import SelectorEstatal from '@/components/mapa/selectores/SelectorEstatal.vue';
import SelectorMunicipal from '@/components/mapa/selectores/SelectorMunicipal.vue';
import '@/components/mapa/selectores/selectores.scss';

import ControlSexo from '@/components/mapa/controles/Sexo.vue';
import ControlEdad from '@/components/mapa/controles/Edad.vue';
import ControlSeguridadSocial from '@/components/mapa/controles/SeguridadSocial.vue';
import ControlResistencia from '@/components/mapa/controles/Resistencia.vue';
import Linfocitos from '@/components/mapa/controles/Linfocitos2.vue';

import ControlReproductor from '@/components/mapa/controles/Reproductor.vue';
import '@/components/mapa/controles/controles.scss';

import VihMunCentroides from '@/components/mapa/capas/VihMunCentroides.js';
import VihMunicipios from '@/components/mapa/capas/VihMunicipios.js';
import VihCpCentroides from '@/components/mapa/capas/VihCpCentroides.js';
import Estados from '@/components/mapa/capas/Estados.js';

import * as d3 from "d3";
import {GeoJSON} from '@/components/mapa/capas/_utils.js';

import datosMapa from '@/assets/data/datos_mapa.json';
import Modal from '@/components/base/Modal.vue';

let componenteMapa;
function zoomExtend(limites) {
  componenteMapa.map.getView().fit(limites, {
    duration: 500,
    padding: [25, 25, 25, 25],
  });
}

export default {
  data() {
    return {
      //capas wms
      estados: new Estados(),
      municipios_wms: new VihMunicipios(),
      vihMunicipios: undefined,
      vihMunCentroides: undefined,
      vihCpCentroides: undefined,

      datosMapa: datosMapa,

      capasWms: [],
      capasWfs: [],
      capasClasificables: [],

      modo: undefined,
      renderCapakey: 0,
      renderCapakeyWms: 0,

      datos_cd4a: [],
      actual_limpieza_mapa: -1,
      data_linfocitos:[],
      vistaMovilExpandida: false,
    };
  },
  mounted() {
    const sumatorias = {
      genero: [510, 183, 7397, 1],
      edad: [4302, 3090, 604, 86, 9],
      seguridad: [1608, 5614, 99, 155, 203, 412],
      resistencia: [6349, 1028, 186, 253, 193, 82], 
    }
    // for (const tipo in sumatorias) {
    //   if (Object.hasOwnProperty.call(sumatorias, tipo)) {
    //     const element = sumatorias[tipo];
    //     console.log(`${tipo}: ${element.reduce((a, b) => a + b, 0)} (${element.toString()})`);
    //   }
    // }

    componenteMapa = this.$refs.componenteMapa;
    this.inicializar();

    d3.csv('data/base_limpia.csv').then((data) => {
      // this.arr = [];
      // data.forEach(d => {
      //   if(d.CD4_A == "" || d.CD4_A == NaN){
      //     // console.log(parseFloat(d.CD4_A));
      //   } else {
      //     this.arr.push(parseFloat(d.CD4_A));
      //   }
      // });
      // this.arr.forEach(d => {
      //   if(typeof(d) != 'number'){
      //     // console.log(d);
      //   }
      // });
      // this.arr.sort(function(a, b) {
      //   return a - b;
      // });
      // console.log("arr",this.arr);
      // this.gdf = d3Collection.nest()
      //             .key(function(d){ return d; })
      //             .rollup(function(a){ return a.length; })
      //             .entries(this.arr)

      // console.log("gdf",JSON.stringify(this.gdf));
      // console.log("length", this.gdf.length);
      // console.log("min_key",d3.min(this.gdf, d => parseFloat(d.key)), "max_key",d3.max(this.gdf, d => parseFloat(d.key) ));
      // console.log("min_value",d3.min(this.gdf, d => d.value), "max_value",d3.max(this.gdf, d => d.value ));
      // this.gdf.forEach(d => {
      //   if(d.value == NaN){
      //     // console.log(d.value);
      //   }
      // });
      // console.log("gdff",this.gdf);
      this.datos_cd4a = data;
      // this.datos_cd4a = this.gdf;
    });
  },
  created:function(){

  },
  methods: {
    ...mapMutations(['reiniciarMapaModo','cambiarMapaCvesMunYModo','quitarMapaCvesMun',]),
    resetMapa() {
      this.reiniciarMapaModo();
    },
    async inicializar() {
      this.modo = this.$store.getters.actualMapaModo;
      //lo wms
      this.municipios_wms.visible = false;

      // los centroides
      if(!this.vihMunCentroides){
        this.vihMunCentroides = new VihMunCentroides();
      }
      this.vihMunCentroides.visible= true;
      if(!this.vihCpCentroides){
        this.vihCpCentroides = new VihCpCentroides();
      }
      this.vihCpCentroides.visible= false;

      this.vihMunCentroides.click = this.clickMun;
      if(!this.vihMunCentroides.geojson){
        this.vihMunCentroides.geojson = new GeoJSON(await this.vihMunCentroides.wfs.cargarGeojson(),"cvegeomun");
      }else{
        //console.log("se le asignara un filtro indefinido a ver si asi...")
        this.vihMunCentroides.geojson.filtro = undefined
      }

      if(!this.vihCpCentroides.geojson){
        this.vihCpCentroides.geojson = new GeoJSON(await this.vihCpCentroides.wfs.cargarGeojson(),"cp");
      }else{
        this.vihCpCentroides.geojson.filtro = undefined
      }

      this.capasClasificables = [this.vihMunCentroides,this.vihCpCentroides];

      //las capas poligonos en vectores
      if(!this.vihMunicipios){
        this.vihMunicipios = new VihMunicipios();
      }
      this.vihMunicipios.click = this.clickMun;
      if(!this.vihMunicipios.geojson){
        this.vihMunicipios.geojson = new GeoJSON(await this.vihMunicipios.wfs.cargarGeojson(),"cvegeomun");
      }else{
        this.vihMunicipios.geojson.filtro = undefined
      }

      // this.vihMunicipios.geojson.filtro = f => f.properties['cvegeomun'].substr(0, 2) === '09';
      this.capasWfs = [this.vihMunicipios];



      //tener preparadas las colonias
    },
    clickMun([feature,]) {
      const cvegeomun = feature.get('cvegeomun');

      if (this.$store.getters.actualMapaCvesMun.includes(cvegeomun)) {
        this.quitarMapaCvesMun(cvegeomun);
      } else {
        // agregar
        this.cambiarMapaCvesMunYModo([...this.$store.getters.actualMapaCvesMun, cvegeomun]);
      }
    },
    aplicarFiltroEstatal(acercamiento=false) {
      const estados = this.$store.getters.actualMapaCvesEdo;
      // Añadir filtro a estados
      this.estados.geoserverFiltro = estados
        .map(edo => `cve_ent='${edo}'`).join(' or ');
      this.estados.wfs.columnas = 'geom';
      // console.log(this.estados.wfs.url);

      if (acercamiento) {
        this.estados.wfs.cargarLimitesTotales.then(limites => zoomExtend(limites));
      }

      //this.vihMunCentroides.geoserverFiltro = estados
      //  .map(edo => `strSubstring(cvegeomun,0,2)='${edo}'`).join(' or ');

      this.vihMunCentroides.geojson.filtro = f => {
        return estados.includes(f.properties["cvegeomun"].substr(0, 2))
      }
      this.vihMunicipios.geojson.filtro = f => {
        return estados.includes(f.properties['cvegeomun'].substr(0, 2))
      };
      this.vihMunCentroides.visible = true;
      this.vihCpCentroides.visible = false;
      //this.capasClasificables = [this.vihMunCentroides]
      /*this.vihMunicipios.geoserverFiltro = estados
        .map(edo => `strSubstring(cvegeomun,0,2)='${edo}'`).join(' or ');*/
      this.municipios_wms.visible = false
    },
    aplicarFiltroMunicial(acercamiento=false) {
      const municipios = this.$store.getters.actualMapaCvesMun;

      // filtro municipal
      let munTemporal = new VihMunicipios();
      munTemporal.z_index = 5;
      munTemporal.geoserverFiltro = municipios.map(mun => `cvegeomun='${mun}'`).join(' or ');
      this.municipios_wms.geoserverFiltro = municipios.map(mun => `cvegeomun='${mun}'`).join(' or ');
      this.municipios_wms.z_index = 5

      if (acercamiento) {
        munTemporal.wfs.columnas = 'geom';
        munTemporal.wfs.cargarLimitesTotales.then(limites => zoomExtend(limites));
      }

      this.aplicarFiltroEstatal();

      //this.vihCpCentroides.wfs.filtro = municipios.map(mun => `cvegeomun='${mun}'`).join(' or ');
      //this.vihCpCentroides.wfs.cargarConteoCoincidencia.then(coincidencia => {
        //if (coincidencia > 0) {

          this.vihCpCentroides.geojson.filtro = f=>{
            return municipios.includes(f.properties["cvegeomun"])
          }
          this.vihCpCentroides.visible = true;
          this.vihMunCentroides.visible = false
          //this.capasClasificables = [this.vihCpCentroides];

        //} else {
          //this.capasClasificables = [];
        //}
      //});
      //this.capasWms = [this.estados, munTemporal];
      this.municipios_wms.visible = true
    },

  },
  computed: {
    ...mapGetters(['actualMapaModoYCves','actualMapaMunicipiosConteos', 'obtenerFechaActualizacion']),
    ...mapState(["conteo_linfocitos"]),
  },
  watch: {
    vistaMovilExpandida(nv){
      setTimeout(() => {
        this.$refs.linfobarras.reescalandoPantalla()
      }, 300);

    },
    actualMapaModoYCves(actual, anterior) {
      //console.log(actual)
      if (actual.modo === 'inicial') {
        componenteMapa.external_force_reset_view();
        this.inicializar();
      }

      if (actual.modo === 'estatal') {
        if (anterior.modo == 'municipal') {
          this.capasWms = [this.estados];
        }
        // console.log('filtrar para estados:', actual.cvesEdo.toString());
        this.aplicarFiltroEstatal(true);
      }

      if (actual.modo === 'municipal') {
        // console.log('filtrar para municipios:', actual.cvesMun.toString());
        this.aplicarFiltroMunicial(true);
      }


      this.$store.dispatch("consultarConteosFiltroMapa");
    },
    actualMapaMunicipiosConteos(actual) {
      //console.log(this.vihMunCentroides)

      if(this.vihMunCentroides && this.vihMunCentroides.geojson){
        this.vihMunCentroides.geojson.forEachFeatureById((feature,id)=>{
          if(id in actual){
            this.vihMunCentroides.geojson.setPropToFeature(id,"tot_muestras",actual[id])
          }else{
            this.vihMunCentroides.geojson.setPropToFeature(id,"tot_muestras",0)
          }
        })
        this.vihMunCentroides.geojson.reasignarFeaturesFromFeaturesById()
        //cambiaronCapas = true;
      }
      if(this.vihMunicipios && this.vihMunicipios.geojson){
        this.vihMunicipios.geojson.forEachFeatureById((feature,id)=>{
          if(id in actual){
            this.vihMunicipios.geojson.setPropToFeature(id,"tot_muestras",actual[id])
          }else if(feature.properties["tot_muestras"] !== null){
            this.vihMunicipios.geojson.setPropToFeature(id,"tot_muestras",0)
          }
        })
        this.vihMunicipios.geojson.reasignarFeaturesFromFeaturesById()
        //cambiaronCapas = true;
      }
      const actual_cps = this.$store.getters.actualMapaCpConteos
      if(this.vihCpCentroides && this.vihCpCentroides.geojson){
        this.vihCpCentroides.geojson.forEachFeatureById((feature,id)=>{
          if(id in actual_cps){
            this.vihCpCentroides.geojson.setPropToFeature(id,"tot_muestras",actual_cps[id])
          }else{
            this.vihCpCentroides.geojson.setPropToFeature(id,"tot_muestras",0)
          }
        })
        this.vihCpCentroides.geojson.reasignarFeaturesFromFeaturesById()
        //cambiaronCapas = true;
      }



    },
    /**
    actualMapaCpConteos(actual) {
      //console.log(this.vihMunCentroides)
      let cambiaronCapas = false;
      if(this.vihCpCentroides && this.vihCpCentroides.geojson){
        this.vihCpCentroides.geojson.forEachFeatureById((feature,id)=>{
          if(id in actual){
            this.vihCpCentroides.geojson.setPropToFeature(id,"tot_muestras",actual[id])
          }else{
            this.vihCpCentroides.geojson.setPropToFeature(id,"tot_muestras",0)
          }
        })
        this.vihCpCentroides.geojson.reasignarFeaturesFromFeaturesById()
        cambiaronCapas = true;
      }

      if(cambiaronCapas){
        this.recargarCapas()
      }

    }
    */
   conteo_linfocitos(nv,ov){
      // console.log("cambio-mapa")
      if(nv != ov){
        this.data_linfocitos = d3.range(0,1400,50).map(
          (d, i) => ({
            rango: [d, d + 50],
            cantidad: Object.keys(nv).includes(String(i)) ? nv[i]:0,
            nombre: `${d}-${d + 50}`
          })
        );
      }
    },
  },
  components: {
    Modal,
    SelectorEstatal,
    SelectorMunicipal,
    ControlSexo,
    ControlEdad,
    ControlSeguridadSocial,
    ControlResistencia,
    Linfocitos,
    ControlReproductor,
  },
};
</script>
